<template>
  <div class="w-full flex flex-col items-end">
    <textarea
      v-model="answer"
      autofocus
      class="w-full rounded-md border-gray-300 border-2 p-2"
      rows="5"
      placeholder="Entrez votre réponse ici..."
    />
    <base-button
      class="mt-3"
      :disabled="!question.optional && !answer"
      @click="emits('onPress', {value: [answer as string]})"
    >
      Suivant
    </base-button>
  </div>
</template>

<script lang="ts" setup>
/**
 * Survey answer component for text input questions.
 *
 * It displays a textarea for the user to input their answer.
 * When the "Next" button is pressed, it emits the 'onPress' event with the entered answer.
 */

import BaseButton from '@/core/components/base/BaseButton.vue';
import {ref} from "vue";
import {SurveyAnswerComponentEmit, SurveyAnswerComponentProps} from "@/survey/components/survey-modal/answers/index";
import {TextInputSurveyQuestion} from "@/core/interfaces/survey/Survey";

defineProps<SurveyAnswerComponentProps<TextInputSurveyQuestion>>();
const emits = defineEmits<SurveyAnswerComponentEmit<TextInputSurveyQuestion>>();
const answer = ref<undefined | string>();
</script>
